import { render, staticRenderFns } from "./FotoPrincipal.vue?vue&type=template&id=05db9cfc&scoped=true&"
import script from "./FotoPrincipal.vue?vue&type=script&lang=js&"
export * from "./FotoPrincipal.vue?vue&type=script&lang=js&"
import style0 from "./FotoPrincipal.vue?vue&type=style&index=0&id=05db9cfc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05db9cfc",
  null
  
)

export default component.exports